module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    name: BD.attr('string'),
    description: BD.attr('string'),
    priority: BD.attr('number'),
    isPredefined: BD.attr('boolean')
})
